module.exports = __webpack_public_path__ + "static/media/024-like.ecda8fcb.svg";